import React from 'react';
import { classNames } from '../utils/utils';

const SubTitle = ({ children, className }) => (
  <h2 className={classNames(className, 'font-light text-lg')}>{children}</h2>
);

export default SubTitle;
